import React, { useState, useMemo } from 'react';
import styles from './approve.module.scss';
import { getIn18Text, IApprovalRecordStatus } from 'api';
import ApprovalActionModal from '@web-approval-flow/components/ApprovalActionModal';
import { APPROVAL_CONFIG } from '@web-approval-flow/components/ApprovalStateTag';
const Approve = props => {
    var _a;
    const { recordFlow, fetchApprovalFlow, checkApproval } = props;
    const recordStatus = useMemo(() => recordFlow === null || recordFlow === void 0 ? void 0 : recordFlow.recordStatus, [recordFlow]);
    const [actionModalInfo, setActionModalInfo] = useState({ visible: false, actionType: 'toApproval', bizName: '', recordId: '' });
    const beApproverEmail = useMemo(() => {
        const { flowList } = recordFlow;
        if (!flowList || flowList.length === 0)
            return '';
        const latestFlow = flowList[0];
        const { accountInfoList } = latestFlow;
        if (!accountInfoList || accountInfoList.length === 0)
            return '';
        return accountInfoList.map(item => (item === null || item === void 0 ? void 0 : item.accName) || '').join(',');
    }, [recordFlow]);
    const showApprove = useMemo(() => {
        if (recordStatus === IApprovalRecordStatus.processing)
            return true;
        return false;
    }, [recordStatus]);
    const approvalData = useMemo(() => {
        const approvalData = APPROVAL_CONFIG[recordStatus];
        return approvalData || {};
    }, [recordStatus]);
    const toCheckApprove = () => {
        checkApproval && checkApproval();
    };
    const agree = async () => {
        setActionModalInfo({
            visible: true,
            actionType: 'toApproval',
            bizName: recordFlow.bizName || '',
            recordId: recordFlow.recordId,
        });
    };
    const reject = async () => {
        setActionModalInfo({
            visible: true,
            actionType: 'toReject',
            bizName: recordFlow.bizName || '',
            recordId: recordFlow.recordId,
        });
    };
    const recall = async () => {
        setActionModalInfo({
            visible: true,
            actionType: 'toRecall',
            bizName: recordFlow.bizName || '',
            recordId: recordFlow.recordId,
        });
    };
    const onActionModalClose = (closeType) => {
        setActionModalInfo({
            visible: false,
            actionType: 'toApproval',
            bizName: '',
            recordId: '',
        });
        if (closeType === 'success') {
            fetchApprovalFlow && fetchApprovalFlow();
        }
    };
    return (React.createElement(React.Fragment, null, showApprove ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.approve, style: { background: ((_a = approvalData === null || approvalData === void 0 ? void 0 : approvalData.style) === null || _a === void 0 ? void 0 : _a.backgroundColor) || '' } },
            React.createElement("div", { className: styles.approveCont },
                React.createElement("span", { className: styles.approveText },
                    getIn18Text('YOUJIANZHUANGT'),
                    "\uFF1A",
                    beApproverEmail,
                    " ",
                    getIn18Text('QINGSHEN'))),
            React.createElement("div", { className: styles.buts },
                !!recordFlow.createByMe && (React.createElement("span", { className: styles.check, onClick: () => toCheckApprove() }, getIn18Text('CHAKAN'))),
                React.createElement("span", { className: styles.agree, onClick: () => agree() }, getIn18Text('TONGYI')),
                React.createElement("span", { className: styles.reject, onClick: () => reject() }, getIn18Text('BOHUI')),
                !!recordFlow.createByMe && (React.createElement("span", { className: styles.recall, onClick: () => recall() }, getIn18Text('CHEHUI'))))),
        React.createElement(ApprovalActionModal, { info: actionModalInfo, onClose: onActionModalClose }))) : (React.createElement(React.Fragment, null))));
};
export default Approve;
